<script>
import { BFormGroup } from 'bootstrap-vue'
import TreeSelect from "@core/components/common/TreeSelect.vue";
import ListOfObjects from "@/views/product/components/product-card/composition/components/ListOfObjects.vue";

export default {
    components: {ListOfObjects, TreeSelect, BFormGroup},
    props: {
        readOnly: {
            default: false,
        },
        label: {
            type: String,
            default: undefined,
        },
        value: {},
        config: {
            type: Object,
            default() {
                return {
                    data: []
                };
            }
        },
        applyWarningClass: {
            type: Boolean,
            default: false,
        },
        appendToBody: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        openOnFocus: {
            type: Boolean,
            default: false,
        },
        menuClass: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            treeselectMandatoryClass: 'treeselect-bg-warning',
        }
    },
    methods: {
        onInput(value) {
            // this.val = value;
            this.$emit('input', value);
        }
    },
    computed: {
        mandatoryClass() {
            return this.applyWarningClass ? this.treeselectMandatoryClass : '';
        },
        labelText() {
            if (this.label === null) {
                return null;
            }
            return this.label || this.$t('Component(CompositionSubstance):material-category');
        },
    },
}
</script>

<template>
    <div>
        <div v-if="readOnly">
            <h5>{{ $t('Component(CompositionSubstance):material-category') }}</h5>

            <div v-if="!value || value.length === 0">-</div>
            <ListOfObjects v-else :elements="value"/>
        </div>
        <b-form-group
            v-else
            :label="labelText"
        >
            <TreeSelect
                :title="$t('Component(CompositionSubstance):hover-material-category')"
                :placeholder="$t('Component(CompositionSubstance):material-category-placeholder')"
                :classes="mandatoryClass"
                :options="config.data"
                :value="value"
                :append-to-body="appendToBody"
                :multiple="multiple"
                :open-on-focus="openOnFocus"
                :menu-class="menuClass"
                @input="onInput"
                @close="$emit('close')"
            />
        </b-form-group>
    </div>
</template>
